import React from "react"

import { withStyles } from '@material-ui/core/styles'
import Grid from '@material-ui/core/Grid'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import CircleIcon from '@material-ui/icons/FiberManualRecord'
import Input from '@material-ui/core/Input'
import { I18n } from 'react-redux-i18n'

const styles = theme => ({
  container: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  formControl:{
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: '50px',
  },
});

class Color extends React.Component {
  render() {
    const { classes } = this.props

    return (
      <Grid container className={classes.container}>
        <Grid item xs={2}>
          <FormControl className={classes.formControl}>
             <InputLabel htmlFor="age-helper">{I18n.t('editAppointment.color')}</InputLabel>
             <Select
               onChange={this.props.handleColorChange}
               value={this.props.updateAppointment.color}
               input={<Input name="age" id="age-helper" />}>
               <MenuItem value={1}><CircleIcon style={{color:"#F44336"}}/></MenuItem>
               <MenuItem value={2}><CircleIcon style={{color:"#4CAF50"}}/></MenuItem>
               <MenuItem value={3}><CircleIcon style={{color:"#2196F3"}}/></MenuItem>
               <MenuItem value={4}><CircleIcon style={{color:"#E91E63"}}/></MenuItem>
               <MenuItem value={5}><CircleIcon style={{color:"#FFEB3B"}}/></MenuItem>
               <MenuItem value={6}><CircleIcon style={{color:"#607D8B"}}/></MenuItem>
               <MenuItem value={7}><CircleIcon style={{color:"#00838F"}}/></MenuItem>
             </Select>
           </FormControl>
        </Grid>
      </Grid>
    )
  }
}

export default withStyles(styles)(Color)



// WEBPACK FOOTER //
// ./src/js/components/pages/updateAppointment/Color.js